import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation ConvertDocumentToSystemTemplateMutation(
    $input: SystemDocumentTemplateFromDocumentInput!
  ) {
    systemDocumentTemplateFromDocument(input: $input) {
      ok
      systemDocumentTemplateId
      redirectUrl
      error
    }
  }
`;

const convertDocumentToTemplate = (environment, variables, callback) => {
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};

export default convertDocumentToTemplate;
